const $inject = ['locationsSearchService', '$scope'];

const lbPoiSelectCtrl = function (locationsSearchService, $scope) {
  let vm = this;

  const MIN_SEARCH_TEXT_LENGTH = 2;
  const MAX_SEARCH_RESULTS = 10;
  const REFRESH_DELAY = 1000;
  const defaultPlaceholderText = 'Destination, airport, train station, landmark or hotel';
  let placeholdertext = vm.placeholdertext || defaultPlaceholderText;

  vm.allowClear = true;
  vm.required = vm.required || false;
  vm.placeholder = vm.disablePlaceholder ? '' : placeholdertext;
  vm.iconClassName = vm.iconClassName || 'ico-marker';
  vm.options = [];
  vm.defaultOptions = vm.defaultOptions || [];
  vm.showLoader = vm.showLoader || false;
  vm.refreshDelay = REFRESH_DELAY;
  vm.grouping = vm.grouping || true;

  vm.refreshOptions = refreshOptions;
  vm.onRemove = onRemove;

  vm.defaultOptions = _.orderBy(vm.defaultOptions, 'Title');

  vm.options = _.clone(vm.defaultOptions);

  $scope.$watch('vm.placeholdertext', (newValue) => {
    vm.placeholder = newValue || defaultPlaceholderText;
  });

  $scope.$watch('vm.options', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      convertToPlural(vm.options);
    }
  });

  function getOriginalCompanyLocations() {
    var result = locationsSearchService.getOriginalCompanyLocations();

    if (result) {
      vm.defaultOptions = _.orderBy(result, 'Title');
      vm.options = result;
    }
  }

  function populateCompanyLocations() {
    if (vm.companyLocationsOnly) {
      locationsSearchService
        .getCompanyLocations({
          maxRows: 0,
          term: '',
          searchTypes: '',
        })
        .then((result) => {
          vm.defaultOptions = _.orderBy(result, 'Title');
          vm.options = result;
        });
    }
  }

  function convertToPlural(options) {
    for (let i = 0; i < options.length; i++) {
      options[i].TypePlural = options[i].Type;
      if (options[i].TypePlural === 'PointOfInterest') {
        options[i].TypePlural = 'Company locations';
      } else if (options[i].TypePlural === 'RailStation') {
        options[i].TypePlural = 'Rail stations';
      } else {
        options[i].TypePlural += 's';
      }
    }
  }

  function refreshOptions(search) {
    if (search.length <= MIN_SEARCH_TEXT_LENGTH && !vm.companyLocationsOnly) {
      return vm.defaultOptions;
    }

    vm.showLoader = true;

    if (vm.companyLocationsOnly) {
      if (search.length <= MIN_SEARCH_TEXT_LENGTH) {
        vm.showLoader = false;
        getOriginalCompanyLocations();
        return vm.defaultOptions;
      } else {
        vm.showLoader = false;
        vm.options = vm.defaultOptions.filter((option) => {
          return option.Title.toLowerCase().indexOf(search.toLowerCase()) > -1;
        });
      }
    } else {
      return locationsSearchService
        .get({
          maxRows: MAX_SEARCH_RESULTS,
          term: search,
          searchTypes: vm.searchtypes,
        })
        .then((result) => {
          vm.defaultOptions = _.orderBy(result, 'Title');
          vm.options = result;
        })

        .finally(() => {
          vm.showLoader = false;
        });
    }
  }

  function onRemove() {
    vm.options = _.clone(vm.defaultOptions);
  }
};

lbPoiSelectCtrl.$inject = $inject;

export default lbPoiSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/lbPoiSelectCtrl.js